import React from "react";
import 'react-datepicker/dist/react-datepicker.css'
import moment from "moment-timezone";
import NTMTable from "components/Table/NTMTable";
import CSVExporter from "components/Table/CSVExporter";

function getValue(field) {
	return field || field === 0 ? `${+field.toFixed(2)}` : "-"
}

const headers1 = [
	{
		Header: "Orario",
		accessor: 'receiptDate',
		Cell: props => <div>{moment(props.original.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm")}</div>
	},
	{
		Header: "Temp est",
		accessor: 'externalTemperature',
		Cell: props => <div>{`${getValue(props.original.externalTemperature)}°`}</div>
	},
	{
		Header: "temp. suolo 1",
		accessor: 'soilTemperature',
		Cell: props => <div>{`${getValue(props.original.soilTemperature)}°`}</div>
	},
	{
		Header: "temp. suolo 2",
		accessor: 'soilTemperature2',
		Cell: props => <div>{`${getValue(props.original.soilTemperature2)}°`}</div>
	},
	{
		Header: "Hum atm",
		accessor: 'externalHumidity',
		Cell: props => <div>{`${getValue(props.original.externalHumidity)}%`}</div>
	},
	{
		Header: "Hum suolo 1",
		accessor: 'soilHumidity',
		Cell: props => <div>{`${getValue(props.original.soilHumidity)} cb`}</div>
	},
	{
		Header: "Hum suolo 2",
		accessor: 'soilHumidity2',
		Cell: props => <div>{`${getValue(props.original.soilHumidity2)} cb`}</div>
	},
	{
		Header: "Bagnat fogliare",
		accessor: 'leafHumidity',
		Cell: props => <div>{`${getValue(props.original.leafHumidity)}%`}</div>
	},
	{
		Header: "Piovosità",
		accessor: 'pluviometer',
		Cell: props => <div>{`${getValue(props.original.pluviometer)} mm`}</div>
	},
	{
		Header: "Radiazione solare",
		accessor: 'radiation',
		Cell: props => <div>{`${getValue(props.original.radiation)} W/mq`}</div>
	},
]

const headers2 = [
	{
		Header: "Orario",
		accessor: 'receiptDate',
		Cell: props => <div>{moment(props.original.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm")}</div>
	},
	{
		Header: "Temp est 2",
		accessor: 'externalTemperature2',
		Cell: props => <div>{`${getValue(props.original.externalTemperature2)}°`}</div>
	},
	{
		Header: "Hum atm 2",
		accessor: 'externalHumidity2',
		Cell: props => <div>{`${getValue(props.original.externalHumidity2)}%`}</div>
	},
	{
		Header: "Vento (vel)",
		accessor: 'windSpeed',
		Cell: props => <div>{`${getValue(props.original.windSpeed)} km/h`}</div>
	},
	{
		Header: "Vento (dir)",
		accessor: 'windDirection',
		Cell: props => <div>{`${props.original.windDirection || "-"}`}</div>
	},
	{
		Header: "Pressione",
		accessor: 'atmPress',
		Cell: props => <div>{`${getValue(props.original.atmPress)} hPa`}</div>
	},
	{
		Header: "Distanza Assoluta",
		accessor: 'absoluteDistance',
		Cell: props => <div>{`${getValue(props.original.absoluteDistance)} cm`}</div>
	},
	{
		Header: "Distanza Relativa",
		accessor: 'relativeDistance',
		Cell: props => <div>{`${getValue(props.original.relativeDistance)} cm`}</div>
	},
]

const headersSolar1 = [
	{
		Header: "Orario",
		accessor: 'receiptDate',
		Cell: props => <div>{moment(props.original.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm")}</div>
	},
	{
		Header: "Temperatura",
		accessor: 'externalTemperature',
		Cell: props => <div>{`${getValue(props.original.externalTemperature)}°`}</div>
	},
	{
		Header: "Radiazione solare",
		accessor: 'radiation',
		Cell: props => <div>{`${getValue(props.original.radiation)} W/mq`}</div>
	},
]

const headersSolar2 = [
	{
		Header: "Orario",
		accessor: 'receiptDate',
		Cell: props => <div>{moment(props.original.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm")}</div>
	},
	{
		Header: "Energia prodotta",
		accessor: 'inverter_energy',
		Cell: props => <div>{`${getValue(props.original.inverter_energy)} kWh`}</div>
	},
]

const headersPest = [
	{
		Header: "Orario",
		accessor: 'receiptDate',
		Cell: props => <div>{moment(props.original.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm")}</div>
	},
	{
		Header: "Conteggio insetti",
		accessor: 'insectCount1',
		Cell: props => <div>{`${getValue(props.original.insectCount1)}`}</div>
	},
	{
		Header: "Conteggio insetti 2",
		accessor: 'insectCount2',
		Cell: props => <div>{`${getValue(props.original.insectCount2)}`}</div>
	},
]


function toCSVdata1(data) {
	return data.map(d => {
		return {
			Orario: moment(d.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm"),
			"Temp esterna": d.externalTemperature,
			"Temp suolo 1": d.soilTemperature,
			"Temp suolo 2": d.soilTemperature2,
			"Hum atmosf": d.externalHumidity,
			"Hum suolo 1": d.soilHumidity,
			"Hum suolo 2": d.soilHumidity2,
			"Bagnatura fogliare": d.leafHumidity,
			"Piovosita": d.pluviometer,
			"Radiazione solare": d.radiation,
		}
	})
}

function toCSVdata2(data) {
	return data.map(d => {
		return {
			Orario: moment(d.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm"),
			"Temp esterna": d.externalTemperature2,
			"Hum atmosf 2": d.externalHumidity2,
			"Vel Vento": d.windSpeed,
			"Dir Vento": d.windDirection,
			"Pressione": d.atmPress,
		}
	})
}

function toCSVdataSolar1(data) {
	return data.map(d => {
		return {
			Orario: moment(d.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm"),
			"Temperatura": d.externalTemperature,
			"Radiazione solare": d.radiation,
		}
	})
}

function toCSVdataSolar2(data) {
	return data.map(d => {
		return {
			Orario: moment(d.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm"),
			"Energia prodotta": d.inverter_energy,
		}
	})
}

function toCSVdataPest(data) {
	return data.map(d => {
		return {
			Orario: moment(d.receiptDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm"),
			"Conteggio insetti 1": d.insectCount1,
			"Conteggio insetti 2": d.insectCount2,
		}
	})
}


export default function Tables({data, type}) {
	
	let header, csvData, csvFileName
	let filteredData = data.filter(d => (!d.type && d.type !== 0) || d.type===type);
	
	switch (type) {
		case 0:
			header = headers1;
			csvFileName = "Agrismart";
			csvData = toCSVdata1(filteredData)
			break;
		case 1:
			header = headers2;
			csvFileName = "Agrismart";
			csvData = toCSVdata2(filteredData)
			break;
		case 3: // radarpest
			header = headersPest;
			csvFileName = "Radarpest";
			csvData = toCSVdataPest(filteredData)
			break;
		case 'solar1':
			header = headersSolar1;
			csvFileName = "Solarsmart";
			csvData = toCSVdataSolar1(filteredData)
			break;
		case 'solar2':
			header = headersSolar2;
			csvFileName = "Solarsmart";
			csvData = toCSVdataSolar2(filteredData)
			break;
		default:
			header = [];
			csvData = [];
			break;
	} 

	return (
		<div style={{ minHeight:400, margin: "1rem auto" }}>
			<CSVExporter title={"Scarica"} name={csvFileName} data={csvData} />
			<NTMTable
				header={header}
				body={filteredData}
				defaultPageSize={20}
			/>
		</div>
	)
}
